const Navlinks = [
  {
    title: 'Home',
    path: '/',
  },

  {
    title: 'About',
    path: '/about',
  },

  {
    title: 'Become Vendor',
    path: '/become-vendor',
  },

  {
    title: 'Contact Us',
    path: '/contactus',
  },

  {
    title: 'FAQs',
    path: '/faqs',
  },
];

export default Navlinks;
